import React, { Component } from "react";
import { Button, Icon, Pagination } from "semantic-ui-react";
import "./styles.scss";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import ProjectForm from "../../components/ProjectForm";
import {
    getProjectList,
    addProject,
    updateProject,
    deleteProject
} from "../../core/actions/projectAction";
import { getProjectTypeList } from "../../core/actions/projectTypeAction";
import { exportFileAction, importFileAction } from "../../core/actions/commonAction";
import ProjectTable from "../../components/ProjectTable";
import CONSTANT from "../../core/constant/constant";
import functionCommon from "../../core/common/function";
import BackToTop from "../../components/BackToTop";

class Project extends Component {
    constructor() {
        super();
        this.state = {
            tableStructure: [
                {
                    label: "labels.id",
                    type: "id",
                    isClass: "first-col"
                },
                {
                    label: "labels.projectType",
                    type: "projectTypeName",
                    sort: true
                },
                {
                    label: "labels.projectCode",
                    type: "projectCode",
                    sort: true
                },
                {
                    label: "labels.projectName",
                    type: "projectName"
                },
                {
                    label: "labels.aliasName",
                    type: "aliasName"
                },
                {
                    label: "labels.activeProject",
                    type: "active",
                    isCheckbox: true
                }
            ],
            paramList: {
                isSearch: 1,
                projectCode: "",
                projectName: "",
                projectTypeId: "",
                aliasName: "",
                active: "",
                defaultProject: "",
                currentPage: 1,
                pageRecord: CONSTANT.pageRecord,
                sortBy: "projectCode-ASC"
            },
            paramProjectTypeList: {
                isSearch: 0,
                projectTypeCode: '',
                projectTypeName: '',
                currentPage: 0,
                pageRecord: CONSTANT.pageRecord,
                sortBy: 'projectTypeCode-ASC'
            },
            project: {
                projectCode: "",
                projectName: "",
                aliasName: "",
                projectTypeId: "",
                active: "",
                defaultProject: ""
            },
            inputSubmit: {
                isSubmit: false,
                formError: {},
                importError: ''
            },
            data: "",
            totalPage: 0,
            activePage: 1,
            disabled: true,
            errorCode: "",
            successCode: "",
            unSelectRow: false,
            isSearch: 1,
            btnDisable: false,
            exportDisabled: false,
            rowId: "",
            file: "",
            importButton: true,
            isAdded: false
        };
    }

    componentWillMount() {
        // Call API project-list, show list project
        this.props.getProjectList(this.state.paramList);
        this.props.getProjectTypeList(this.state.paramProjectTypeList);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.projectReducer.isLoading) {
            this.clearProject();
            if (this.state.isAdded === true) {
                this.getList();
            } else {
                this.props.getProjectList(this.state.paramList);
            }
        } else {
            let data = nextProps.projectReducer.dataProject.result;
            this.setState({
                data: data,
                totalPage: nextProps.projectReducer.dataProject.totalPage,
                activePage: nextProps.projectReducer.dataProject.currentPage || 1,
                btnDisable: false
            });

            // No data
            if (!data || (data && !data[0])) {
                this.setState({
                    errorCode: "018",
                    exportDisabled: true
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.projectReducer.errorCode = "";
                    }.bind(this),
                    2000
                );

            } else {
                this.setState({
                    errorCode: "",
                    exportDisabled: false
                });
            }

            // Data have success code
            if (nextProps.projectReducer.successCode) {
                this.setState({
                    successCode: nextProps.projectReducer.successCode,
                });
                if (this.state.isAdded === true) {
                    this.clearParamList(false);
                }
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.projectReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }

            if (nextProps.projectReducer.errorCode) {
                this.setState({
                    errorCode: nextProps.projectReducer.errorCode,
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.projectReducer.errorCode = "";
                    }.bind(this),
                    2000
                );
            }

        }
    }

    async getList() {
        let clrParam = await this.clearParamList(false);
        return this.props.getProjectList(this.state.paramList);       
    }

    // Event when click btn Search
    async searchProject() {
        this.clearError();
        this.setState({ btnDisable: true });
        const projectCode = this.state.project.projectCode;
        const projectName = this.state.project.projectName;
        const projectTypeId = this.state.project.projectTypeId;
        const aliasName = this.state.project.aliasName;
        const active = this.state.project.active;
        const defaultProject = this.state.project.defaultProject;

        await this.setState({
            paramList: {
                isSearch: 1,
                projectCode: projectCode,
                projectName: projectName,
                projectTypeId: projectTypeId,
                aliasName: aliasName,
                currentPage: 1,
                active: active === true ? 1 : "",
                defaultProject: defaultProject === true ? 1 : "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            },
            disabled: true,
            unSelectRow: false,
            isSearch: 1,
            activePage: 1
        });

        return this.props.getProjectList(this.state.paramList);
    }

    // Event when click btn Add
    addProject = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const projectCode = this.state.project.projectCode;
        const projectName = this.state.project.projectName;
        const aliasName = this.state.project.aliasName;
        const projectTypeId = this.state.project.projectTypeId;
        const active = this.state.project.active;
        const defaultProject = this.state.project.defaultProject;
        this.setState({ isAdded: true });
        return this.props.addProject({
            projectCode: projectCode,
            projectName: projectName,
            aliasName: aliasName,
            projectTypeId: projectTypeId,
            active: active === true ? 1 : 0,
            defaultProject: defaultProject === true ? 1 : 0
        });
    }

    // Event when click btn Update 
    updateProject = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        const projectCode = this.state.project.projectCode;
        const projectName = this.state.project.projectName;
        const aliasName = this.state.project.aliasName;
        const projectTypeId = this.state.project.projectTypeId;
        const active = this.state.project.active;
        const defaultProject = this.state.project.defaultProject;
        this.setState({ isAdded: false });
        return this.props.updateProject({
            id: id,
            projectCode: projectCode,
            projectName: projectName,
            aliasName: aliasName,
            projectTypeId: projectTypeId,
            active: active === true ? 1 : 0,
            defaultProject: defaultProject === true ? 1 : 0
        });

    }

    // Delete project
    deleteProject = async () => {
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        this.clearProject();

        if (this.state.data.length === 1) {
            this.setState(prevState => ({
                paramList: {
                    ...prevState.paramList,
                    currentPage: 1
                }
            }));
        }
        this.setState({ isAdded: false });
        return this.props.deleteProject({ id: id });
    }

    // Event when click btn Export
    projectExportAction = () => {
        this.clearError();
        const exportParam = {
            projectCode: this.state.paramList.projectCode,
            projectName: this.state.paramList.projectName,
            aliasName: this.state.paramList.aliasName,
            projectTypeId: this.state.paramList.projectTypeId,
            active: this.state.paramList.active,
            defaultProject: this.state.paramList.defaultProject,
            sortBy: this.state.paramList.sortBy
        };
        this.props.exportFileAction(
            {
                urlGetkey: "Project/requestSecretKey",
                urlDownfile: "Project/projectExport"
            },
            exportParam
        );
    }

    // Event when click clear project
    clearProject = () => {
        this.setState({
            project: {
                projectCode: "",
                projectName: "",
                aliasName: "",
                projectTypeId: "",
                active: "",
                defaultProject: ""
            },
            disabled: true,
            unSelectRow: false,
            rowId: "",
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            file: null,
            importButton: true
        });
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear param list call API
    clearParamList = (isSort) => {
        this.setState({
            paramList: {
                isSearch: 0,
                projectCode: "",
                projectName: "",
                aliasName: "",
                projectTypeId: "",
                active: "",
                defaultProject: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: (isSort !== true) ? "projectCode-ASC" : this.state.paramList.sortBy
            },
        });
    }

    // Handle on change input
    changeProject = evt => {
        const name = evt.target.name;
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
        this.setState(prevState => ({
            project: {
                ...prevState.project,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));

    }

    // Event when click table row
    onRowClick = val => {
        this.clearError();
        let _project = {
            projectCode: val.projectCode !== null ? val.projectCode : "",
            projectName: val.projectName !== null ? val.projectName : "",
            projectTypeId: val.projectTypeId !== null ? val.projectTypeId : "",
            aliasName: val.aliasName !== null ? val.aliasName : "",
            active: val.active === "1" ? true : false,
            defaultProject: val.defaultProject === "1" ? true : false
        };
        this.setState({
            disabled: false,
            project: _project,
            unSelectRow: true,
            rowId: val.id
        });
    }

    // Event when click sort table
    sortBy = async val => {
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                sortBy: val,
                rowId: val.id
            }
        }));
        this.props.getProjectList(this.state.paramList);
    }

    // Event when click btn pagination
    async handlePaginationChange(val) {
        await this.setState({
            activePage: val,
            paramList: {
                isSearch: this.state.isSearch,
                projectCode: this.state.paramList.projectCode,
                projectName: this.state.paramList.projectName,
                aliasName: this.state.paramList.aliasName,
                projectTypeId: this.state.paramList.projectTypeId,
                active: this.state.paramList.active,
                defaultProject: this.state.paramList.defaultProject,
                currentPage: val,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            }
        });

        return this.props.getProjectList(this.state.paramList);
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};

        (this.state.project.projectCode.trim() === '') ? _formError['projectCode'] = 'message.200' : _formError['projectCode'] = '';
        (this.state.project.projectName.trim() === '') ? _formError['projectName'] = 'message.201' : _formError['projectName'] = '';
        (this.state.project.projectTypeId === '') ? _formError['projectTypeId'] = 'message.202' : _formError['projectTypeId'] = '';

        if (this.state.project.projectCode.trim() !== ''
            && this.state.project.projectName.trim() !== ''
            && this.state.project.projectTypeId !== '') {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }
        return isValidate;
    }

    // import file
    handleChangeFileInput = (value) => {
        const file = value.target.files[0]
        if (!file) return
        if ((file.size / 1024 / 1024 < 2) && functionCommon.checkfile(file) == true) {
            if (value.target.files[0]) {
                this.setState({
                    file: value.target.files[0],
                    importButton: false,
                });
            } else {
                this.setState({
                    importButton: true
                });
            }
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    importError: ""
                }
            }));
        } else {
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    importError: "message.010"
                }
            }));
            this.setState({
                file: '',
                importButton: true,
            });
        }

    }

    projectImportAction = () => {
        const fileName = this.state.file ? this.state.file : null;
        this.fileUpload(fileName);
    }

    fileUpload = file => {
        const fileUpload = file;
        this.props.importFileAction(
            {
                urlGetkey: "project/requestSecretKey",
                urlDownfile: "project/projectImport"
            },
            fileUpload
        );
    };


    render() {
        const { t } = this.props;
        const { activePage, errorCode, successCode, btnDisable } = this.state;
        return (
            <div className="project-wrap">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = "/employee" }, 500)}>
                        {t("navigation.master")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>
                        {t("navigation.project")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.searchProject()}
                    >
                        <Icon name="search" />
                        {t("button.search")}
                    </Button>
                    <Button
                        primary
                        disabled={this.state.btnDisable}
                        onClick={() => this.addProject()}
                    >
                        <Icon name="add circle" />
                        {t("button.add")}
                    </Button>
                    <Button
                        primary
                        disabled={this.state.disabled}
                        className="update-btn"
                        onClick={() => this.updateProject()}
                    >
                        <Icon name="edit" />
                        {t("button.update")}
                    </Button>
                    <Button
                        primary
                        disabled={this.state.disabled}
                        onClick={() => this.deleteProject()}
                        className="delete-btn"
                    >
                        <Icon name="trash alternate outline" />
                        {t("button.delete")}
                    </Button>
                    <Button
                        disabled={this.state.importButton}
                        onClick={e => this.projectImportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.import")}
                    </Button>
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.projectExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                    <Button
                        onClick={() => this.clearProject()}
                    >
                        <Icon name="refresh" />
                        {t("button.clearAll")}
                    </Button>
                </div>
                <ProjectForm
                    projectData={this.state.project}
                    projectTypeData={this.props.projectTypeReducer.dataProjectType.projectTypeList}
                    isError={this.state.inputSubmit.formError}
                    changeProject={input => this.changeProject(input)}
                    handleChangeFileInput={input => this.handleChangeFileInput(input)}
                    importFile={this.state.file}
                    isImportError={this.state.inputSubmit.importError}
                />
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {(errorCode == "010") ? t("message.023") : t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    onRowClick={val => this.onRowClick(val)}
                    unSelectRow={this.state.unSelectRow}
                    defaultSort={this.state.paramList.sortBy}
                    sortBy={val => this.sortBy(val)}
                />
                <div className="table-paging">
                    {this.state.data && this.state.data[0] ? (
                        <Pagination
                            size="tiny"
                            activePage={activePage}
                            firstItem={null}
                            lastItem={null}
                            totalPages={this.state.totalPage}
                            prevItem={{
                                disabled: this.state.activePage == 1,
                                content: <Icon name="chevron left" />,
                                icon: true
                            }}
                            nextItem={{
                                disabled: this.state.activePage == this.state.totalPage,
                                content: <Icon name="chevron right" />,
                                icon: true
                            }}
                            onPageChange={(e, { activePage }) =>
                                this.handlePaginationChange(activePage)
                            }
                        />
                    ) : (
                            ""
                        )}
                </div>
                <BackToTop />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getProjectList: opt => dispatch(getProjectList(opt)),
    getProjectTypeList: opt => dispatch(getProjectTypeList(opt)),
    addProject: opt => dispatch(addProject(opt)),
    updateProject: opt => dispatch(updateProject(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param)),
    deleteProject: opt => dispatch(deleteProject(opt)),
    importFileAction: (url, param) => dispatch(importFileAction(url, param)),
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(Project);
